import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import Article_Boutique from '@/classes/Articles/Article_Boutique.class';

export const useArticlesBoutiqueStore = defineStore('ArticlesBoutique', {
    state: () => ({
        id_module: null,
        list: [],
    }),
    actions: {
        /**
         * Fetches all articles from the boutique using the PublicService.
         * If the response is successful, it sets the articles in the store.
         * 
         * @async
         * @function fetchAll
         * @returns {Promise<void>} A promise that resolves when the articles are fetched and set.
         */
        async fetchAll() {
            this.list = [];
            let res = await PublicService.getArticlesBoutique(this.id_module);
            if (res) {
                this.set(res);
            }
        },
        /**
         * Sets the list of articles in the store.
         *
         * @param {Array} data - An array of article data objects.
         */
        set(data) {
            this.list = [];
            for (let i = 0; i < data.length; i++) {
                let article = new Article_Boutique();
                article.set(data[i]);
                this.list.push(article);
            }
        }
    },
    getters: {
        /**
         * Filters the list of articles to return only those that are visible on the homepage.
         *
         * @returns {Array} An array of articles where `visible_accueil` is equal to '1'.
         */
        visibles_accueil() {
            return this.list.filter(article => article.visible_accueil == '1');
        },
        /**
         * Calculates the total number of reservations in the list.
         *
         * @returns {number} The total number of reservations.
         */
        total_order() {
            let total = 0;
            for (let i = 0; i < this.list.length; i++) {
                total += this.list[i].nb_reservations;
            }
            return total;
        }

    },
});